import i18n from 'i18next';

export const componentStyleModes = {
    SYSTEM: 1,
    CUSTOM: 2
};

export const getComponentStyleModeOptions = () => [
    {
        label: i18n.t('label.game_setting.check_in.style_system'),
        value: componentStyleModes.SYSTEM
    },
    { label: i18n.t('label.game_setting.check_in.style_custom'), value: componentStyleModes.CUSTOM }
];
